<main id="main" class="main">
  <!-- Header -->
  <div class="row m-1">
    <div
      class="col-12 col-md-12 d-flex justify-content-between"
      style="background: #5d7c9b !important; font-size: 14px"
    >
      <h6 class="title">
        Payments &nbsp;&nbsp;
        <i class="bi bi-info-circle"></i>
      </h6>
    </div>
  </div>

  <!-- Filter -->
  <div class="row m-1">
    <!-- payment type -->
    <div class="col-12 col-md-3">
      <div class="form-group">
        <label for="filterPaymentType">Payment Type</label>
        <select
          id="filterPaymentType"
          class="form-control"
          placeholder="Select"
          [(ngModel)]="filterPaymentType"
          (change)="onPaymentTypeChange($event)"
        >
          <option value="" label="" selected>Select</option>
          <option [value]="'ADVISOR'">Advisor</option>
          <option [value]="'PARTNER'">Partner</option>
          <option [value]="'CUSTOMER'">Customer</option>
        </select>
      </div>
    </div>
    <!-- month / month range -->
    <div class="col-12 col-md-3" *ngIf="filterPaymentType">
      <div class="form-group">
        <div>
          <input
            type="radio"
            id="filterMonth"
            name="filterIsMonthRange"
            [value]="false"
            [(ngModel)]="filterIsMonthRange"
            (change)="onRangeChange()"
          />
          <label class="form-check-label ps-1 my-auto" for="filterMonth">
            Month
          </label>
          &nbsp;
          <input
            type="radio"
            id="filterRange"
            name="filterIsMonthRange"
            [value]="true"
            [(ngModel)]="filterIsMonthRange"
            (change)="onRangeChange()"
          />
          <label class="form-check-label ps-1 my-auto" for="filterRange">
            Range
          </label>
        </div>
        <input
          *ngIf="filterIsMonthRange; else elseMonthRange"
          type="text"
          [(ngModel)]="filterDateSelection"
          class="form-control"
          placeholder="Select Month"
          bsDaterangepicker
          [bsConfig]="{ rangeInputFormat: 'MMM YYYY', minMode: 'month' ,showWeekNumbers: false}"
          [maxDate]="maxDateForPicker"
        />
        
        <ng-template #elseMonthRange>
          <input
            type="text"
            [(ngModel)]="filterDateSelection"
            class="form-control"
            placeholder="Select Month"
            bsDatepicker
            [bsConfig]="{ dateInputFormat: 'MMM YYYY', minMode: 'month',showWeekNumbers: false }"
            [maxDate]="maxDateForPicker"
          />
        </ng-template>
      </div>
    </div>
    <div class="col-12 col-md-3" *ngIf="filterDateSelection">
      <div class="form-group">
        <label for="multiSelectMembers" class="form-check-label">
          Select Payee/Payor
        </label>
        <ng-multiselect-dropdown
          [placeholder]="'Select'"
          [settings]="dropdownSettings"
          [data]="advisors"
          [(ngModel)]="filterAdvisors"
          (onSelect)="onItemSelect($event)"
          (onSelectAll)="onSelectAll($event)"
        >
        </ng-multiselect-dropdown>
      </div>
    </div>
    <div class="col-12 col-md-3">
      <div class="form-group">
        <label for="filterReportType"></label>
        <div class="d-flex gap-2 mb-3">
          <button
            class="btn btn-primary"
            style="font-size: 12px"
            (click)="applyFilters()"
            title="Apply Filters"
          >
            Apply filter
          </button>

          <button
            class="btn btn-secondary"
            style="font-size: 12px"
            (click)="resetFilters()"
            title="Reset Filters"
          >
            Reset filter
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Datatable -->
  <div class="row m-1 mt-4" *ngIf="isView">
    <div class="table-responsive">
      <table
        datatable
        [dtOptions]="dtOptions"
        [dtTrigger]="dtTrigger"
        id="DataTables_Table_1"
        class="table text-nowrap"
      >
        <thead>
          <tr>
            <th style="width: 30px">#</th>
            <th
              *ngFor="let header of tableHeaders | parseHeaders"
              [ngStyle]="{
                'width.px':
                  header === 'Status' ||
                  header === 'Payment Status' ||
                  header === 'Progress Status'
                    ? 100
                    : 'auto'
              }"
            >
              {{ header | titlecase }}
            </th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of data; let i = index">
            <td>{{ i + 1 }}</td>
            <ng-container *ngFor="let field of tableHeaders | parseValues">
              <td [ngSwitch]="field">
                <!-- Case for 'date' field -->
                <ng-container *ngSwitchCase="'date'">
                  {{ item[field] | date : "MMMM yyyy" }}
                </ng-container>

                <ng-container *ngSwitchCase="'progressStatus'">
                  <!-- <div class="text-center" *ngIf="item[field] === 'Completed'">
                    <img
                      src="assets/img/report/completed.png"
                      alt=""
                      width="20px"
                      height="20px"
                    />
                  </div>
                  <div
                    class="text-center"
                    *ngIf="item[field] === 'In Progress'"
                  >
                    <img
                      src="assets/img/report/in-progress.png"
                      alt=""
                      width="20px"
                      height="20px"
                    />
                  </div>
                  <div
                    class="text-center"
                    *ngIf="
                      item[field] === 'Requested' || item[field] === 'Queued'
                    "
                  >
                    <img
                      src="assets/img/report/queued.png"
                      alt=""
                      width="20px"
                      height="20px"
                    />
                  </div>
                  <div class="text-center" *ngIf="item[field] === 'Cancelled'">
                    <img
                      src="assets/img/report/cancelled.png"
                      alt=""
                      width="20px"
                      height="20px"
                    />
                  </div> -->
                  <div class="progress">
                    <div
                      *ngIf="item[field] === 'Completed'"
                      class="progress-bar bg-success"
                      role="progressbar"
                      style="width: 100%"
                      aria-valuenow="25"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    >
                      {{ item[field] }}
                    </div>
                    <div
                      *ngIf="
                        item[field] === 'In Progress' ||
                        item[field] === 'Requested' ||
                        item[field] === 'Queued'
                      "
                      class="progress-bar progress-bar progress-bar-striped progress-bar-animated"
                      role="progressbar"
                      style="width: 100%"
                      aria-valuenow="25"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    >
                      {{ item[field] }}
                    </div>
                    <div
                      *ngIf="item[field] === 'Cancelled'"
                      class="progress-bar bg-warning"
                      role="progressbar"
                      style="width: 100%"
                      aria-valuenow="25"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    >
                      {{ item[field] }}
                    </div>
                  </div>
                </ng-container>

                <!-- Case for 'status' field -->
                <ng-container *ngSwitchCase="'paymentStatus'">
                  <!-- <button class="paymentStatus" (click)="showPayment(item)">
                    {{ item[field] }}
                  </button> -->
                  {{ item[field] }}
                </ng-container>

                <!-- Default case for other fields -->
                <ng-container *ngSwitchDefault>
                  {{ item[field] }}
                </ng-container>
              </td>
            </ng-container>
            <!-- <ng-container *ngFor="let field of tableHeaders | parseValues">
              <td *ngIf="field === 'date'; else notDate">
                {{ item[field] | date : "MMMM yyyy" }}
              </td>
              <ng-template #notDate>
                <td>{{ item[field] }}</td>
              </ng-template>
            </ng-container> -->
            <td>
              <div style="min-width: 20px" data-bs-target="showmemberlist">
                <a
                  class="viewicon"
                  title="View Detail"
                  data-toggle="tooltip"
                  style="cursor: pointer; margin-right: 10px"
                  *ngIf="actions?.includes('view')"
                >
                  <i
                    class="bi bi-eye-fill"
                    style="color: rgb(56, 66, 159); cursor: pointer"
                    (click)="viewDetail(item)"
                  ></i>
                </a>
                <a
                  class="viewicon"
                  title="Download Excel"
                  data-toggle="tooltip"
                  style="cursor: pointer; margin-right: 10px"
                  *ngIf="actions?.includes('xlsx')"
                >
                  <i
                    class="bi bi-file-earmark-excel-fill"
                    style="color: rgb(56, 159, 108); cursor: pointer"
                    (click)="downloadExcelReport(item)"
                  ></i>
                </a>

                <a
                  class="viewicon"
                  title="View PDF"
                  data-toggle="tooltip"
                  style="cursor: pointer; margin-right: 10px"
                  *ngIf="actions?.includes('pdf')"
                >
                  <i
                    class="bi bi-file-earmark-pdf-fill"
                    style="color: rgb(159, 56, 56); cursor: pointer"
                    (click)="viewPdf(item)"
                  ></i>
                </a>

                <a
                  class="viewicon"
                  title="Adjustment"
                  data-toggle="tooltip"
                  style="cursor: pointer; margin-right: 10px"
                  *ngIf="item.paymentStatus === 'Not Paid'"
                >
                  <i
                    class="bi bi-sliders"
                    style="color: rgb(56, 75, 159); cursor: pointer"
                    (click)="viewAdjustment(item)"
                  ></i>
                </a>

                <a
                  class="viewicon"
                  title="Finalize report and Publish"
                  data-toggle="tooltip"
                  style="cursor: pointer; margin-right: 10px"
                  *ngIf="item.reportStatus === 'Draft'"
                >
                  <i
                    class="bi bi-check-circle"
                    style="color: rgb(56, 159, 99); cursor: pointer"
                    (click)="viewFinalize(item)"
                  ></i>
                </a>

                <a
                  class="viewicon"
                  title="Send Invite"
                  data-toggle="tooltip"
                  *ngIf="actions?.includes('email')"
                >
                  <i
                    class="fa fa-send-o cursor: pointer;"
                    style="color: rgb(56, 76, 159); cursor: pointer"
                    (click)="invitationMail(item)"
                  >
                  </i>
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</main>
